import script from "./ContactTableComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactTableComponent.vue?vue&type=script&setup=true&lang=js"

import "./ContactTableComponent.vue?vue&type=style&index=0&id=1e025666&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e025666"]])

export default __exports__